import { render, staticRenderFns } from "./PlatformPersonalData.vue?vue&type=template&id=b96c6524"
import script from "./PlatformPersonalData.vue?vue&type=script&lang=js"
export * from "./PlatformPersonalData.vue?vue&type=script&lang=js"
import style0 from "./PlatformPersonalData.vue?vue&type=style&index=0&id=b96c6524&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports